import { FieldValidator } from '@/modules/dynamic-form/models/FieldValidator.model';

import { interpretMessage } from '../../utils/interpret-message/interpretMessage';
import { CustomMessageOptions } from '../type';

const MESSAGE = 'Required';

export function createRequiredValidator(
    // nullable in case of null is being considered as valid value such as ExtractionField
    nullable?: boolean,
    msgOptions?: CustomMessageOptions,
): FieldValidator {
    const validate = (val: any) => {
        if (val === undefined || val === '') {
            const message = msgOptions?.customMsg || MESSAGE;
            return interpretMessage(message, { field: msgOptions?.fieldName || 'field' });
        }

        // Check if value is null
        // If nullable is true: null is considered valid (field requirement is satisfied)
        // If nullable is false: null is considered invalid (field must have a value)
        if (val === null) {
            if (nullable) {
                return true; // null is explicitly valid when nullable is true
            }
            const message = msgOptions?.customMsg || MESSAGE;
            return interpretMessage(message, { field: msgOptions?.fieldName || 'field' });
        }

        // Value exists and is not null/undefined/empty string
        return true;
    };

    return { name: 'required', validate };
}
